import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Divider, Tooltip, IconButton, Typography } from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Loader from "../../../../../utilityComponents/Loader";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import ReportTable from './reportTable.jsx'

const customStyles = {
  table: {
    style: {
      border: "solid 1px black",
      marginTop: "20px",
      maxWidth: "70%",
      position:"relative"
    },
  },
  header: {
    style: {
      marginLeft: "12px",
    },
  },

  tableWrapper: {
    style: {
      padding: "12px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      fontSize: 16,
      '&:hover': {
				cursor: 'pointer',
			},
    },

  },
  headCells: {
    style: (header, index) => {
      
      return header.column.name.toUpperCase() != "result".toUpperCase() &&
        header.column.name.toUpperCase() != "Total occurrence".toUpperCase()
        ? {
            paddingLeft: "8px",
            paddingRight: "8px",
            backgroundColor: "#b0ff45",
            justifyContent: "center",
            borderRight: "1px solid black",
          }
        : {
            paddingLeft: "8px",
            paddingRight: "8px",
            backgroundColor: "#b0ff45",
            justifyContent: "center",
          };
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
      borderTop: "1px solid black",
    },
  },
};
const signalCell = {
  cells: {
    style: {
      cursor: "auto",
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
      borderTop: "1px solid black",
    },
  },
};

const Overall = (props) => {
  const [testreport, setTestReport] = useState([]);
  const [signalReport, setSignalReport] = useState([]);
  const [overallDetails, setOverallDetails] = useState({});
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(true);
  


  const summaryColumns=[
    {
      header: "Metric",
      accessorKey: "columnname",
      cell: (props) => {
        return (
          
          <p style={{ wordBreak:"break-all",textAlign:'center'}}>
          {props.row.original.clickable ? <a onClick={()=>Triggger(props.row.original)} style={{color:"#0056b3"}}> {props.getValue()}</a>:
          <p>
            {props.getValue()}
          </p>
          }
          </p>
         
        );
      },
    },
    {
      header: "Count",
      accessorKey: "count",
      cell: (props) => {
        return (
          <p style={{ wordBreak:"break-all",textAlign:'center'}}>
            {props.getValue()}
          </p>
        );
      }
    }
  ]

  const signalsColumns = [
    {
      name: "Signals",
      selector: (row) => row.columnname,
      sortable: true,

      style: {
        borderRight: "1px solid black",
        textTransform: "uppercase"
      }
    },
    {
      name: "Total occurrence",
      selector: (row) => row.count,
      sortable: true,
    },
  ];
    
  const handleReportDownload = async () => {
    const fileToDownload = await axios.post(
      "/generate-presigned-url",
      {
        s3_location: overallDetails.summary_xlsx_report,
      }
    );
    window.open(fileToDownload.data.presigned_url);
  }
 
  const fetchPRData = async (reporting_level, test_run_id, execution_id) => {
    let payload;

    if (reporting_level == "test_run_id") {
      payload = {
        test_run_id,
        reporting_level,
        execution_id,
      };
    } else if (reporting_level == "execution_id") {
      payload = {
        reporting_level,
        execution_id,
      };
    }
    if(props.pageParam.modeType && props.pageParam.modeType === "reporting")
      payload={
        cad_topology_job_uuid:execution_id
      };
    try {
      setLoader(true);
      let response;
      if(!props.pageParam.modeType)
         response = await axios.post(
          "/cm/open_loop/pr/scenario-overall-details/summary",
          payload
        );
      else if(props.pageParam.modeType=="reporting")
        response = await axios.post('/cm/reporting-mode/pr-reporting/fetch-overall-details',payload);

      const test_summary =
        response.data.scenarios_executed.overall_summary.test_summary;
      const signal_summary =
        response.data.scenarios_executed.overall_summary.signal_summary;
    
      setOverallDetails(response.data);
      setTestReport(test_summary);
      setSignalReport(signal_summary);
    } catch (error) {
      console.log("Error", error);

      if (
        error.response && error.response.data && error.response.data.Status
      ) {
        
          setError({ ErrorMsg: error.response.data.Status });
      } else setError({ ErrorMsg: "Error occured" });
    } finally {
     
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchPRData(
      props.pageParam.reporting_level,
      props.pageParam.test_run_id,
      props.pageParam.execution_id
    );

  }, []);
 
  const Triggger = (e) => {
    props.handlePage(e.key)
  };
  if (error) {
    return <h1 data-test="Error">{error.ErrorMsg}</h1>;
  }

  return loader ? (
    <Loader data-test="Loading"/>
  ) : (
    <Box
      data-test="Page"
      style={{
        padding: "20px",
        overflowX: "hidden",
      }}
    >
      <Grid
        container
        style={{
          fontWeight: 400,
          fontSize: "16px",
          backgroundColor: "white",
          border: "solid 1px rgba(0,0,0,.2)",
          borderRadius: "10px",
          padding: "10px",
          margin: "0px",
          width: '100%',
        }}
        
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="h5">Execution Details</Typography>
          </Grid>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
          {overallDetails.summary_xlsx_report_flag &&
              <Tooltip placement="top" title={<h6>Download Summary Report</h6>}>
                <IconButton
                  aria-label="download"
                  onClick={handleReportDownload}
                >
                  <CloudDownloadIcon />
                </IconButton>
              </Tooltip>}
          </Grid>
        </Grid>
 
        <Grid container spacing={3} style={{ marginTop: "10px" }}>
          <Grid item xs={2}>
            Model
          </Grid>
          <Grid item xs={3}>
            {overallDetails.model}
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={2}>
            Subject Under Test
          </Grid>
          <Grid item xs={3}>
            {overallDetails.execution}
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={2}>
            Executed By
          </Grid>
          <Grid item xs={3}>
            {overallDetails.executed_by}
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={2}>
            Timestamp
          </Grid>
          <Grid item xs={3}>
            {overallDetails.startdate}
          </Grid>
        </Grid>
        
        <Grid container spacing={3}>
          <Grid item xs={2}>
            CAD Topology Job UUID 
          </Grid>
          <Grid item xs={5}>
            {overallDetails.scenarios_executed.cad_topology_job_uuid}
          </Grid>
        </Grid>
      
        {props.pageParam.modeType!=="reporting"?<Grid container spacing={3}>
          <Grid item xs={2}>
            Execution UUID
          </Grid>
          <Grid item xs={5}>
            {overallDetails.scenarios_executed.overall_summary.execution_uuid}
          </Grid>
        </Grid>:null}
      </Grid>

      <Divider style={{ margin: "20px 0" }} />

      <>
        <div
          data-test="Table-1"
          style={{
            padding: "1rem",
            position: "relative",
            background: "white",
            borderRadius: "10px",
            marginTop: "30px",
            padding: "12px",
          }}
        >
          <h5 style={{marginBottom:"25px"}}>Execution Summary</h5>


          <ReportTable
          columns={summaryColumns}
          data={testreport}
          />
        </div>
        <Divider style={{ margin: "20px 0" }} />
        <div
          data-test="Table-2"
          style={{
            padding: "1rem",
            position: "relative",
            background: "white",
            marginTop: "30px",
            borderRadius: "10px",
          }}
        >
          <DataTable
            title="Activation Summary"
            columns={signalsColumns}
            data={signalReport}
            customStyles={{
              ...customStyles,

              ...signalCell,
            }}
            
            
          />
        </div>
      </>
    </Box>
  );
};

export default Overall;